<template>
    <form-card>
        <form class="ai-login-form" @submit.prevent="onSubmit">
            <dx-form :form-data="formData" :disabled="loading">
                <dx-simple-item
                    data-field="login"
                    editor-type="dxTextBox"
                    :editor-options="{ stylingMode: 'filled', placeholder: 'Логин' }"
                >
                    <dx-required-rule message="Поле должно быть заполнено" />
                    <dx-label :visible="false" />
                </dx-simple-item>
                <dx-simple-item
                    v-if="showPasswordInput"
                    data-field="password"
                    editor-type="dxTextBox"
                    :editor-options="passwordInputOptions"
                >
                    <dx-required-rule message="Поле должно быть заполнено" />
                    <dx-label :visible="false" />
                </dx-simple-item>

                <dx-simple-item>
                    <dx-button
                        id="ai-login-form-submit-button"
                        height="50"
                        width="100%"
                        type="default"
                        :use-submit-behavior="true"
                    >
                        <div>
                            <span class="dx-button-text">
                                <dx-load-indicator v-if="loading" width="24px" height="24px" :visible="true" />
                                <span id="ai-login-form-submit-button-text" v-if="!loading"> Вход </span>
                            </span>
                        </div>
                    </dx-button>
                    <div class="ai-login-form__restore-link">
                        <router-link to="/infoenergo/restore"> Восстановить доступ </router-link>
                    </div>
                </dx-simple-item>
            </dx-form>
        </form>
    </form-card>
</template>

<script setup>
import DxLoadIndicator from 'devextreme-vue/load-indicator';
import DxForm, { DxSimpleItem, DxRequiredRule, DxLabel } from 'devextreme-vue/form';
import { DxButton } from 'devextreme-vue';
import { reactive, ref, computed, onBeforeMount } from 'vue';
import FormCard from '../../../src/layouts/auth-layout/components/form-card.vue';
import { useRouter } from 'vue-router';
import { loginApi } from '@/service/auth-service';
import { setCookie, deleteCookie } from '@/utils/cookies';
import { DxUiNotify } from '@/utils/dx-ui-notify';
import { initialRoutes, routes } from '@/router';
import enviromentStore from '@/store/enviroment-data';
const { removeEnvData } = enviromentStore;

const url = ref();

const formData = reactive({
    login: '',
    password: '',
});

const isContentReady = ref(false);
const passwordEditorOptions = ref({});
const showPasswordInput = computed(() => isContentReady.value);
const loading = ref(false);
const router = useRouter();
const isPasswordVisible = ref(false);

onBeforeMount(() => {
    deleteCookie('token');
    deleteCookie('renewal');
    deleteCookie('app');
    deleteCookie('dep');
    removeEnvData();
    routes.forEach(route => {
        if (!initialRoutes.find(el => el.name === route.name) && router.hasRoute(route)) {
            router.removeRoute(route);
        }
    });

    url.value = window.location.href;
    passwordEditorOptions.value = {
        mode: url.value.includes('localhost') || (url.value.includes('asusejs-dev.infoenergo.loc') && 'password'),
    };
    isContentReady.value = true;
});

async function onSubmit() {
    const { login, password } = formData;
    const { result, token, renewal } = await loginApi(login, password);
    if (!result) {
        loading.value = false;
        DxUiNotify.error('Неверный логин или пароль', 2000);
    } else {
        setCookie('token', token);
        setCookie('renewal', renewal);
        setCookie('login', login);

        router.push({ name: 'AppDepartmentSelect' });
    }
}

const passwordInputOptions = computed(() => ({
    stylingMode: 'filled',
    placeholder: 'Пароль',
    buttons: [
        {
            location: 'after',
            name: 'changePasswordVisibilityButton',
            options: {
                icon: changePasswordVisibilityIcon.value,
                onClick: changePasswordVisibility,
            },
        },
    ],
    ...(passwordEditorOptions.value.mode
        ? { mode: isPasswordVisible.value ? 'text' : 'password' }
        : {
              inputAttr: {
                  style: isPasswordVisible.value ? '-webkit-text-security: none' : '-webkit-text-security: disc',
              },
          }),
}));

const changePasswordVisibilityIcon = computed(() =>
    isPasswordVisible.value ? './assets/password-visibility-off.svg' : './assets/password-visibility-on.svg'
);

const changePasswordVisibility = () => {
    isPasswordVisible.value = !isPasswordVisible.value;
};
</script>

<style lang="scss" scoped>
.ai-login-form :first-child :first-child :first-child :first-child {
    :is(.dx-item, .dx-box-item) :first-child :first-child {
        padding-bottom: 2px;
        :is(.dx-field-item-content, .dx-field-item-content-location-bottom):has(
                > :first-child :is(.dx-texteditor-container)
            ) {
            padding: 5px 5px;
            background-color: #fff;
            border-radius: 8px;
            border: 1px solid #03142533;
            :first-child {
                background-color: #fff;
                :first-child {
                    :first-child {
                        font-family: Golos, GolosText, sans-serif;
                        font-size: 16px;
                        :is(.dx-placeholder) {
                            font-family: Golos, GolosText, sans-serif;
                            font-size: 16px;
                        }
                    }
                }
                :has(.dx-texteditor-buttons-container) {
                    :has(.dx-button-content) {
                        :first-child {
                            padding-top: 2px;
                            padding-bottom: 0px;
                        }
                    }
                }
            }
        }
    }
}
.ai-login-form {
    display: flex;
    flex-direction: column;
    gap: 1px;
    width: 380px;
    &__restore-link {
        text-align: center;
        font-size: 1rem; /* 12px */
        line-height: 1rem; /* 16px */
        margin-top: 12px;
        :first-child {
            color: #03142580;
        }
    }
    &__restore-link:hover {
        text-align: center;
        font-size: 1rem; /* 12px */
        line-height: 1rem; /* 16px */
        margin-top: 12px;
        :first-child {
            color: #6698cc;
        }
    }
}
#ai-login-form-submit-button {
    border-radius: 8px;
    font-size: 14px;
    text-transform: none;
    margin-top: 15px;
}
#ai-login-form-submit-button-text {
    text-transform: none;
}
.dx-widget.dx-button.dx-button-mode-contained.dx-button-normal.dx-button-has-icon {
    background-color: black;
}
</style>
